import React, { useMemo } from "react";
import {
  FiArchive,
  FiCheckCircle,
  FiFolder,
  FiPauseCircle,
  FiPlayCircle,
} from "react-icons/fi";

import "./ProjectStatusSummary.css";

const STATUS_CARDS = [
  { key: "ALL", label: "Total Projects", description: "All projects", icon: FiFolder, tone: "total" },
  { key: 0, label: "Active Projects", description: "Currently active", icon: FiPlayCircle, tone: "active" },
  { key: 2, label: "On Hold", description: "Temporarily paused", icon: FiPauseCircle, tone: "hold" },
  { key: 1, label: "Completed", description: "Delivery completed", icon: FiCheckCircle, tone: "completed" },
  { key: 3, label: "Closed", description: "Projects closed", icon: FiArchive, tone: "closed" },
];

export default function ProjectStatusSummary({ projects = [], selected, onSelect }) {
  const counts = useMemo(
    () => projects.reduce(
      (result, project) => {
        const status = Number(project.projectStatus);
        result.ALL += 1;
        if (Object.prototype.hasOwnProperty.call(result, status)) result[status] += 1;
        return result;
      },
      { ALL: 0, 0: 0, 1: 0, 2: 0, 3: 0 },
    ),
    [projects],
  );

  return (
    <section className="project-status-summary" aria-label="Project status filters">
      {STATUS_CARDS.map((card) => {
        const Icon = card.icon;
        const active = selected === card.key;
        return (
          <button
            key={card.key}
            type="button"
            className={`project-status-card project-status-card--${card.tone}${active ? " project-status-card--selected" : ""}`}
            onClick={() => onSelect(card.key)}
            aria-pressed={active}
          >
            <span className="project-status-card__icon"><Icon /></span>
            <span className="project-status-card__content">
              <span className="project-status-card__label">{card.label}</span>
              <strong>{counts[card.key] ?? 0}</strong>
              <small>{card.description}</small>
            </span>
          </button>
        );
      })}
    </section>
  );
}
